import type { PrazoDoSistema, UnidadeDePrazo } from './contrato';

/** Agrupa os prazos por categoria, preservando a ordem de `ordem` dentro de cada uma. */
export function agruparPorCategoria(
  prazos: PrazoDoSistema[] | undefined,
): Array<[string, PrazoDoSistema[]]> {
  const grupos = new Map<string, PrazoDoSistema[]>();
  for (const prazo of prazos ?? []) {
    const atual = grupos.get(prazo.categoria);
    if (atual) {
      atual.push(prazo);
    } else {
      grupos.set(prazo.categoria, [prazo]);
    }
  }
  for (const lista of grupos.values()) {
    lista.sort((a, b) => a.ordem - b.ordem);
  }
  return Array.from(grupos.entries());
}

/**
 * Feriados nacionais de data fixa, em `DD-MM`.
 *
 * APROXIMAÇÃO, e de propósito: os móveis (Carnaval, Sexta-feira Santa, Corpus
 * Christi) dependem da Páscoa, e os municipais dependem de norma local. O cálculo
 * que vale é o do banco, quando a função existir; este aqui serve só ao
 * simulador da tela, que é uma estimativa e se anuncia como tal.
 */
const FERIADOS_FIXOS = [
  '01-01',
  '21-04',
  '01-05',
  '07-09',
  '12-10',
  '02-11',
  '15-11',
  '20-11',
  '25-12',
] as const;

function ehDiaUtil(data: Date): boolean {
  const diaDaSemana = data.getDay();
  if (diaDaSemana === 0 || diaDaSemana === 6) {
    return false;
  }
  const dia = String(data.getDate()).padStart(2, '0');
  const mes = String(data.getMonth() + 1).padStart(2, '0');
  return !FERIADOS_FIXOS.includes(`${dia}-${mes}` as (typeof FERIADOS_FIXOS)[number]);
}

/**
 * A data de vencimento de um prazo a partir de uma data base.
 *
 * Função pura, sem API: é aritmética de calendário, e roda inteira no navegador.
 * Por isso o simulador da tela funciona sem a API, e se anuncia como estimativa.
 */
export function calcularVencimento(base: Date, valor: number, unidade: UnidadeDePrazo): Date {
  const data = new Date(base);
  switch (unidade) {
    case 'DIAS_CORRIDOS':
      data.setDate(data.getDate() + valor);
      return data;
    case 'MESES':
      data.setMonth(data.getMonth() + valor);
      return data;
    case 'ANOS':
      data.setFullYear(data.getFullYear() + valor);
      return data;
    case 'DIAS_UTEIS': {
      let restantes = valor;
      while (restantes > 0) {
        data.setDate(data.getDate() + 1);
        if (ehDiaUtil(data)) {
          restantes -= 1;
        }
      }
      return data;
    }
  }
}
